import { render } from "./MessageContainer.vue?vue&type=template&id=4539de3c&scoped=true&ts=true"
import script from "./MessageContainer.vue?vue&type=script&lang=ts"
export * from "./MessageContainer.vue?vue&type=script&lang=ts"

import "./MessageContainer.vue?vue&type=style&index=0&id=4539de3c&scoped=true&lang=css"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4539de3c"]])

export default __exports__